import React from "react";
import { fileUrl } from "../../lib/api";

const REVEALED_STATUSES = ["in_production", "delivered"];

export default function CurrentSponsorsList({ age, sponsorships, jerseyStatus }) {
    const reveal = REVEALED_STATUSES.includes(jerseyStatus);

    return (
        <section id="sponsors" className="scroll-mt-20">
            <h2 className="font-display text-3xl uppercase tracking-tight mb-6">
                Sponsors actuels — {age}
            </h2>
            {sponsorships.length === 0 ? (
                <div className="card-tu text-zinc-500 text-center py-12">
                    Aucun sponsor pour le moment. Soyez le premier !
                </div>
            ) : (
                <>
                    {!reveal && (
                        <p className="text-xs uppercase tracking-widest text-orange-500 mb-3" data-testid="sponsors-anonymous-notice">
                            Les noms des sponsors seront révélés une fois le maillot en production.
                        </p>
                    )}
                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
                        {sponsorships.map((s) => (
                            <div key={s.id} className="card-tu p-4 text-center">
                                <div className="bg-zinc-950 h-20 flex items-center justify-center mb-2 border border-zinc-800">
                                    {reveal ? (
                                        <img
                                            src={fileUrl(s.logo_path)}
                                            alt={s.sponsor_company}
                                            className="max-h-16 max-w-full object-contain"
                                        />
                                    ) : (
                                        <div className="text-zinc-600 text-xs uppercase tracking-widest">
                                            Sponsor confirmé
                                        </div>
                                    )}
                                </div>
                                <div className="text-xs font-bold text-zinc-200 truncate" data-testid={`sponsor-name-${s.id}`}>
                                    {reveal ? s.sponsor_company : "—"}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </section>
    );
}
